<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
    <path style="fill:#83E26F;" d="M241.317,105.322c-55.896,41.585-87.115,90.787-102.15,151.989
        c-3.572,14.586-5.582,28.597-6.132,41.897c-5.645-3.709-11.314-7.892-16.996-12.525c-7.081-5.782-13.487-11.813-19.256-18.057
        C36.729,204.139,41.35,118.772,44.022,87.103c2.048-24.189-5.157-56.907-9.716-74.565C32.309,4.833,30.822,0,30.822,0
        c15.785,4.371,30.695,8.841,44.769,13.424c59.03,19.194,103.312,40.361,136.042,65.124
        C222.848,87.028,232.701,95.932,241.317,105.322z"/>
    <path style="fill:#5ECE4A;" d="M241.32,105.322c-55.903,41.587-87.116,90.784-102.153,151.992
        c-3.575,14.578-5.58,28.593-6.13,41.888c-5.646-3.706-11.316-7.885-17.002-12.522c-7.073-5.777-13.478-11.815-19.255-18.05
        c1.114-6.863,2.528-13.779,4.231-20.682c8.684-35.366,21.847-66.224,40.265-94.359c18.311-27.978,41.365-52.564,70.364-75.039
        C222.852,87.024,232.702,95.93,241.32,105.322z"/>
    <path style="fill:#56BA3E;" d="M218.872,153.644c-7.526-9.253-37.492-44.647-45.611-53.492c-4.664-5.083-12.565-5.421-17.644-0.756
        c-5.081,4.664-5.418,12.564-0.756,17.645c8.675,9.45,39.134,45.504,47.082,55.415"/>
    <path style="fill:#83E26F;" d="M463.494,118.473c2.947,34.829,7.636,118.081-35.261,194.562c0,0,0,0-0.012,0.014
        c-14.395,25.672-34.147,50.572-61.143,72.63c-124.08,101.381-244.492,33.492-233.49-94.963c0.917-10.727,2.751-21.887,5.58-33.401
        C168.769,136.772,261.138,62.833,481.176,1.859C481.175,1.859,459.564,71.961,463.494,118.473z"/>
    <path style="fill:#5ECE4A;" d="M428.219,313.048c-14.395,25.673-34.147,50.572-61.143,72.631
        c-124.08,101.381-244.492,33.492-233.49-94.963C215.687,453.985,426.136,314.436,428.219,313.048z"/>
    <g>
        <path style="fill:#56BA3E;" d="M141.401,388.006c-12.137,34.129-22.012,70.574-28.801,109.35
            c-1.19,6.793,3.354,13.265,10.146,14.455c0.728,0.127,1.454,0.189,2.168,0.189c5.952,0,11.224-4.272,12.286-10.336
            c5.542-31.652,13.223-61.699,22.562-90.151l9.532-26.987c7.373-19.523,15.505-38.24,24.23-56.149
            c12.679-0.042,26.426,1.188,41.827,3.755c0.696,0.116,1.386,0.172,2.068,0.172c5.994-0.001,11.285-4.33,12.303-10.436
            c1.134-6.803-3.462-13.238-10.265-14.372c-11.86-1.977-22.881-3.218-33.303-3.769c13.663-25.369,28.439-48.97,43.765-70.824
            c11.669-1.852,23.612-0.471,36.233,1.002c4.411,0.514,8.971,1.046,13.632,1.454c0.37,0.032,0.737,0.049,1.101,0.049
            c6.405-0.001,11.858-4.901,12.427-11.401c0.601-6.871-4.482-12.927-11.353-13.528c-4.302-0.377-8.68-0.887-12.915-1.38
            c-6.636-0.773-13.381-1.553-20.269-1.893c12.947-16.874,26.116-32.548,39.191-47.035c14.29-4.027,30.92-4.492,48.119-1.332
            c6.787,1.234,13.293-3.244,14.538-10.026c1.245-6.782-3.243-13.293-10.026-14.54c-8.702-1.598-17.331-2.409-25.736-2.461
            c7.709-7.739,15.308-15.053,22.72-21.929c5.056-4.69,5.354-12.591,0.663-17.649c-4.689-5.055-12.591-5.354-17.648-0.663
            c-19.551,18.134-40.328,39.179-61.152,63.135c-4.092-6.843-10.384-13.441-19.77-17.963c-6.213-2.993-13.677-0.383-16.671,5.829
            c-2.993,6.214-0.385,13.677,5.829,16.671c9.925,4.783,11.883,13.895,12.272,17.333c-15.509,19.191-30.847,40.02-45.524,62.488
            c-4.084-6.019-9.984-11.686-18.335-15.71c-6.211-2.993-13.675-0.385-16.671,5.829c-2.993,6.214-0.385,13.677,5.829,16.671
            c11.677,5.627,12.334,17.277,12.372,18.588l-0.001-0.165h1.051c-16.852,28.229-32.505,58.795-46.12,91.717L141.401,388.006z"/>
        <path style="fill:#56BA3E;" d="M145.099,88.676c-2.448,2.572-5.732,3.871-9.029,3.871c-3.097,0-6.206-1.149-8.617-3.459
            c-20.555-19.631-62.577-53.211-93.147-76.55C32.309,4.833,30.822,0,30.822,0c15.785,4.371,30.695,8.841,44.769,13.424
            c22.665,18.37,59.23,48.153,69.108,57.594C149.682,75.789,149.869,83.693,145.099,88.676z"/>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
</svg>

</template>

<script>
export default {
    name: 'LeafIcon'
}
</script>

<style>

</style>